import PropTypes from 'prop-types';
import React from 'react';

const Pin = ({ className, color, onClick }) => (
  <svg className={className} onClick={onClick} viewBox="0 0 24 24" fill="none">
    <g id="wt.pin">
      <path
        id="Vector"
        d="M20 10.25C20 14.8063 12 22 12 22C12 22 4 14.8063 4 10.25C4 5.69365 7.58172 2 12 2C16.4183 2 20 5.69365 20 10.25Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

Pin.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

Pin.defaultProps = {
  color: '#333333',
};

export default Pin;
